// Constants

// people.language holds the full language name. The rename-and-add-languages
// migration cascaded 'deutsch' -> 'german' (and 'français' -> 'french'), so map
// the stored name to the email composer's de/en/fr locale (defaulting to en).
export const PERSON_LANGUAGE_LOCALE = {
    german: 'de',
    deutsch: 'de',
    english: 'en',
    french: 'fr',
    'français': 'fr',
    francais: 'fr',
};

export const personLocale = (person) =>
    PERSON_LANGUAGE_LOCALE[(person.language?.() ?? '').toLowerCase()] ?? 'en';

export const GIFT_CARD_STATUSES = [
    {'title': 'Enabled - Paid for', 'value': 'enabled'},
    {'title': 'Redeemed - Used', 'value': 'redeemed'},
    {'title': 'Created - not yet paid for', 'value': 'created'},
    {'title': 'Failed', 'value': 'failed'},
    {'title': 'Expired', 'value': 'expired'},
    {'title': 'Canceled', 'value': 'canceled'}
];

export const PRODUCT_TYPES = [
    {'title': 'Gutschein', 'value': 'giftcard'},
    {'title': 'Ständchen', 'value': 'serenade'},
    {'title': 'Trauerfeier', 'value': 'trauerfeier-paket'}
];

export const COST_CENTER = [
    {value: "AD", hint: "AD - Administration / Verwaltung"},
    {value: "CMBC", hint: "CMBC - B2C Online Marktplatz"},
    {value: "CMBB", hint: "CMBB - B2B Projekte Fokus Live Events"},
    {value: "CO", hint: "CO - B2B Projekte Fokus Medialeistung"},
    {value: "PD", hint: "PD - Produktentwicklung"}
]

export const VAT_KEY = [
    {value: "9", hint: "9 = 19%"},
    {value: "8", hint: "8 = 7%"},
    {value: "1", hint: "kein VSt. = Kleinunternehmer/umsatzsteuerbefreit"},
    {value: "94", hint: "94 = Reverse Charge"},
    {value: "x", hint: "x = unklar, bitte überprüfen"}
]

export const DATEVK_KEY = [
    {value: "730", hint: "730 = bar ausgelegt, muss erstattet werden"},
    {value: "70000", hint: "70000 = wurde oder wird vom Konto aus bezahlt"},
    {value: "70100", hint: "70100 = Facebook Abrechnung"},
    {value: "70200", hint: "70200 = Google Abrechnung"}
]

export const DATEVW_KEY = [
    {value: "42..", hint: "42.. = Miete, Strom etc. wie bisher"},
    {value: "4630", hint: "4360 = Versicherungen"},
    {value: "4390", hint: "4390 = Sonstige Abgaben (KSK, GEMA)"},
    {value: "4600", hint: "4600 = Material und Werbekosten sonstige"},
    {value: "4601", hint: "4601 = Google SEA"},
    {value: "4602", hint: "4602 = Social Media"},
    {value: "4603", hint: "4603 = Streuartikel (Sticker, Flyer)"},
    {value: "4604", hint: "4604 = Displays"},
    {value: "4605", hint: "4605 = Affiliate"},
    {value: "4606", hint: "4606 = Rabatte und Promotion Codes"},
    {value: "4650", hint: "4650 = Bewirtungskosten"},
    {value: "4653", hint: "4653 = Aufmerksamkeiten"},
    {value: "4660", hint: "4660 = Reisekosten Arbeitnehmer"},
    {value: "4662", hint: "4662 = Reisekosten Arbeitnehmer, Fahrtkosten (Kfz)"},
    {value: "4664", hint: "4664 = Verpflegungsmehraufwand"},
    {value: "48..", hint: "48.. = Abschreibungen"},
    {value: "4900", hint: "4900 = Sonstige betriebliche Aufwendungen"},
    {value: "4910", hint: "4910 = Porto"},
    {value: "4920", hint: "4920 = Telefon"},
    {value: "4930", hint: "4930 = Bürobedarf"},
    {value: "4945", hint: "4945 = Weiterbildung"},
    {value: "4950", hint: "4950 = Rechts- und Beratungskosten"},
    {value: "4955", hint: "4955 = Buchführungskosten"},
    {value: "4970", hint: "4970 = Nebenkosten des Geldverkehrs"},
    {value: "4971", hint: "4971 = Gebühren Mangopay"},
    {value: "4980", hint: "4980 = Sonstiger Betriebsbedarf"},
    {value: "4990", hint: "4990 = IT sonstige Aufwendungen"},
    {value: "4991", hint: "4991 = Software Lizenzen"},
    {value: "4992", hint: "4992 = Domain Kosten"},
    {value: "4993", hint: "4993 = Server Kosten"},
    {value: "3100", hint: "3100 = sonstige Fremdleistungen und Fremdarbeiten"},
    {value: "3101", hint: "3101 = IT Dienstleistungen"},
    {value: "3102", hint: "3102 = Foto/Film-Produktionen"},
    {value: "3103", hint: "3103 = Grafik Dienstleistungen"},
    {value: "3104", hint: "3104 = Online Marketing Dienstleistungen"},
    {value: "3105", hint: "3105 = Künstlergagen"},
    {value: "3106", hint: "3106 = Gewinnspiel Gutscheine an Kunden - neu (20/09)"},
    {value: "3107", hint: "3107 = Medienlizenzen Musik/Bil"}
]

export const PAYMENT_TERMS = [
    { 'title': 'A -7 days after invoice', value: 'after invoice' },
    { 'title': 'B - 7 days before delivery (concert)', value: 'before delivery' },
    { 'title': 'C - After delivery (after concert date)', value: 'after delivery' }
]

export const ARTIST_STATUSES = [
    { title: 'created', value: 'created' },
    { title: 'published', value: 'published' },
    { title: 'applied', value: 'applied' },
    { title: 'approved', value: 'approved' },
    { title: 'pro', value: 'pro' },
    { title: 'deleted', value: 'removed' }
]
